import dayjs from 'dayjs';
import 'dayjs/locale/fr';

dayjs.locale('fr');

/**
 * Formats a notification date.
 * @param {string} date - The creation date.
 * @param {boolean} compact - Short format ("Aujourd'hui · 09:12").
 * @returns {string} - The formatted date.
 */
export const formatNotificationDate = (date, compact = false) => {
  const now = dayjs();
  const createdAt = dayjs(date);
  const yesterday = now.subtract(1, 'day').startOf('day');
  const isToday = now.isSame(date, 'day');
  const isYesterday = yesterday.isSame(date, 'day');

  let formattedDate;

  if (isToday) {
    formattedDate = `Aujourd'hui${compact ? ' · ' : ' à '}${createdAt.format(
      'HH:mm'
    )}`;
  } else if (isYesterday) {
    formattedDate = `Hier${compact ? ' · ' : ' à '}${createdAt.format(
      'HH:mm'
    )}`;
  } else {
    formattedDate = createdAt.format(compact ? 'D MMM YYYY' : 'DD MMMM YYYY');
  }

  return formattedDate;
};
